import React from 'react'

import { useLogisticFilters } from 'hooks/useLogisticFilters'
import { logisticApi } from 'redux/services/logistic'

// import { LogisticReportType } from 'redux/services/logistic/types'
import { AppButton } from 'components/AppButton'
import AppDatePicker from 'components/AppDatePicker/AppDatePicker'
import { AppFiltersLayout } from 'components/AppFiltersLayout'
import { AppSelect } from 'components/AppSelect'
import { TextField } from 'components/TextField'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'

interface Props {
  onSubmit?: () => void
  reset?: () => void
}

const defaultListValue = {
  title: 'Все',
  value: '',
}

export const Filters: React.FC<Props> = ({ onSubmit, reset }) => {
  const { params, setParam } = useLogisticFilters()
  const { data: projects } = logisticApi.useGetProjectsQuery()
  const { data: cardTypes } = logisticApi.useGetCardTypesQuery()
  // const [downloadExcel, downloadExcelState] =
  //   logisticApi.useDownloadLogisticExcelMutation()

  const statusList = Object.entries(LOGISTIC_STATUS_TEXT).map(
    ([value, title]) => ({
      title,
      value,
    }),
  )
  const projectsList = (projects || [])?.map(p => ({
    title: p.name,
    value: p.id,
  }))
  const cardTypesListList = (cardTypes || [])?.map(p => ({
    title: p.name,
    value: p.id,
  }))

  return (
    <AppFiltersLayout
      controls={
        <>
          <AppButton size="small" onClick={onSubmit}>
            Применить
          </AppButton>
          <AppButton size="small" variant="red" onClick={reset}>
            Сбросить
          </AppButton>
          {/* <br />
          <br />
          <AppButton
            onClick={() => downloadExcel({ params })}
            disabled={downloadExcelState.isLoading}
            variant="siren_dashed_border"
            size="small"
          >
            Скачать отчет
          </AppButton>
          <AppButton
            onClick={() =>
              downloadExcel({ params, type: LogisticReportType.BY_DAY })
            }
            disabled={downloadExcelState.isLoading}
            variant="siren_dashed_border"
            size="small"
          >
            Ежедневный отчёт
          </AppButton>
          <AppButton
            onClick={() =>
              downloadExcel({ params, type: LogisticReportType.BY_MONTHS })
            }
            disabled={downloadExcelState.isLoading}
            variant="siren_dashed_border"
            size="small"
          >
            Ежемесячный отчёт
          </AppButton> */}
        </>
      }
    >
      <TextField
        inputSize="small"
        onChange={e => setParam('search', e.currentTarget.value)}
        value={params.search}
        name="search"
        label="Название"
        placeholder="Введите название"
      />
      <TextField
        inputSize="small"
        onChange={e => setParam('barcode', e.currentTarget.value)}
        value={params.barcode}
        name="barcode"
        label="ID Карты"
        placeholder="ID Карты"
      />
      <AppSelect
        size="extra_small"
        text={statusList.find(item => item.value === params.status)?.title}
        onChangeValues={value => setParam('status', value?.[0] || '')}
        list={[defaultListValue, ...statusList]}
        placeholder="Все"
        label="Статус"
      />
      <AppSelect
        size="extra_small"
        text={
          projectsList.find(item => item.value === Number(params.project))
            ?.title
        }
        onChangeValues={value => setParam('project', value?.[0] || '')}
        list={[defaultListValue, ...projectsList]}
        placeholder="Все"
        label="Проект"
      />
      <AppSelect
        size="extra_small"
        text={
          cardTypesListList.find(
            item => item.value === Number(params.card_type),
          )?.title
        }
        onChangeValues={value => setParam('card_type', value?.[0] || '')}
        list={[defaultListValue, ...cardTypesListList]}
        placeholder="Все"
        label="Тип карты"
      />
      <AppDatePicker
        label="Начало"
        inputSize="small"
        value={params.start_date || ''}
        onchange={date => {
          setParam('start_date', date)
        }}
      />
      <AppDatePicker
        label="Конец"
        inputSize="small"
        value={params.end_date || ''}
        onchange={date => {
          setParam('end_date', date)
        }}
      />
    </AppFiltersLayout>
  )
}
